import { Grid } from "@material-ui/core";
import { Footer } from "../components/Footer";
import { Header } from "../components/Header";
import banner from "../images/banner.jpg";
import * as data from '../Data'
import { getCookie } from 'typescript-cookie'
import { Link } from "react-router-dom";
import { Member } from "../interfaces/Member";
import { useEffect, useState } from "react";
import image1 from '../images/image_1.jpg';
import image2 from '../images/image_2.jpg';
import image3 from '../images/image_3.jpg';

export function MemberRewardCredits() {
    const [owner, setOwner] = useState<Member>();

    useEffect(() => {
        const ownerCookie = getCookie('owner') || undefined;

        if (ownerCookie) {
            setOwner(JSON.parse(ownerCookie) as Member);
        } else {
            window.location.href = "/login";
        }
    }, [])

    return (
        <div>

            {owner && <Header owner={owner} />}

            {owner &&
            <div>
                <Grid container>
                    <Grid item xs={12}>
                        <div style={{ width: '100%', margin: '0px' }}>
                            <img src={banner} style={{ width: '100%' }} alt='beach image' />
                        </div>
                        <div style={{
                            fontSize: '2.5em',
                            fontFamily: 'Assistant',
                            fontWeight: 'bold',
                            width: '100%',
                            textAlign: 'center',
                            margin: '10px'
                        }}>
                            Member Reward Credits
                        </div>
                    </Grid>
                </Grid>
                
                <Grid container style={{ marginBottom: '60px' }}>
                    <Grid item xs={12}>
                        <div style={{
                            margin: 'auto',
                            width: '50%',
                            lineHeight: '130%',
                            fontSize: '1.15em',
                        }}>
                            <div style={{ marginTop: '20px' }}>
                                Beyond exclusive year-round member pricing on travel-related services with <b>Epic Experiences</b>,
                                you can also earn <b>Rewards Credits</b> on eligible purchases.
                            </div>
                            <div style={{ marginTop: '20px' }}>
                                Rewards Credits accumulate automatically and can be used toward future qualifying Epic
                                Experiences, helping you save more as you plan your next getaway again and again.
                            </div>
                            <div style={{ marginTop: '20px' }}>
                                Track your balance anytime: your current Rewards Credits balance is available in Epic Experiences under My Account.
                            </div>
                            <div style={{ marginTop: '20px', textAlign: 'center' }}><b>Redeeming Reward Credits</b></div>
                            <div style={{ marginTop: '20px' }}>
                                When you book a travel service, you’ll be able to view pricing in cash or Rewards Credits. If
                                your credit balance doesn’t cover the full purchase, the system applies what you have and shows
                                the remaining amount due.
                            </div>
                            <div style={{ marginTop: '20px' }}>Earn as you go. Redeem when you’re ready. Travel smarter every time.</div>
                       </div>
                    </Grid>
                </Grid>
            </div>
            }

            {owner && <Footer />}
        </div>
    )
}